import { ColorNeutralDarkGrey, Spacing8 } from 'autogen/design-tokens/tokens';
import type { PointDiscountViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import type { IBody } from 'components/generic/typography/components/Body';
import Status from 'components/Status';
import styled from 'styled-components';

const Wrapper = styled(Typography.Body)`
    display: flex;
    align-items: center;
    color: ${ColorNeutralDarkGrey};
`;

export type PointDiscountLineProps = PointDiscountViewModel & IBody;

function PointDiscountLine(props: PointDiscountLineProps) {
    const { text, isDiscountable, ...restProps } = props;

    return (
        <Wrapper size="S" {...restProps}>
            {text}
        </Wrapper>
    );
}

export default PointDiscountLine;
